import { useAPIService } from "../../../hooks/useAPIService"

export function LoginPage({children}){
  const { getImagem } = useAPIService()

  return (
    <div className="login-page">
      <div className="login-box">
        <div className="login-logo">
          <img 
            src={getImagem(process.env.REACT_APP_LOGO)} 
            alt="Logo" 
            width="300"
          />
        </div>
        {children}
      </div>
    </div>
  )
}